<i18n>
  {
    "fr": {
      "you-use-ie": "Vous consultez ce site avec Microsoft Internet Explorer <b>mais celui-ci n'est pas capable d'afficher correctement son contenu !</b><br />Merci d'utiliser <b>Firefox</b>, <b>Chrome</b> ou <b>Edge</b>."
    }
  }
</i18n>

<template>
  <div id="app">
    <div v-if="ie" id="ie-warning" class="ie-warning" v-html="$t('you-use-ie')"></div>
    <router-view class="content-view"/>
    <footer :class="{'hide': hideFooter}">
      <a href="https://crealp.ch" target="_blank"><img class="crealp-logo" src="./assets/images/logo/crealp.png" /></a>
      <img class="vs-logo-footer" src="./assets/images/logo/vs_text.png" />
      <img class="gaia-logo" src="./assets/images/logo/gaia.jpg" />
    </footer>
  </div>
</template>

<script>

import UAParser from 'ua-parser-js'

let useragent = new UAParser()

export default {
  name: 'App',
  data () {
    return {
      hideFooter: false
    }
  },
  computed: {
    browser () {
      return useragent.getBrowser()
    },
    ie () {
      return this.browser.name === 'IE'
    }
  },
  mounted () {
    // init locale for datepicker
    this.$material.locale = {
      startYear: 1900,
      endYear: 2099,
      dateFormat: 'dd.MM.yyyy',
      days: ['Dimanche', 'Lundi', 'Mardi', 'Mercredi', 'Jeudi', 'Vendredi', 'Samedi'],
      shortDays: ['Dim', 'Lun', 'Mar', 'Mer', 'Jeu', 'Ven', 'Sam'],
      shorterDays: ['D', 'L', 'Ma', 'Me', 'J', 'V', 'S'],
      months: ['Janvier', 'Février', 'Mars', 'Avril', 'Mai', 'Juin', 'Juillet', 'Août', 'Septembre', 'Octobre', 'Novembre', 'Décembre'],
      shortMonths: ['Jan', 'Fev', 'Mar', 'Avr', 'Mai', 'Juin', 'Jui', 'Août', 'Sept', 'Oct', 'Nov', 'Dec'],
      shorterMonths: ['J', 'F', 'M', 'A', 'M', 'Ju', 'Ju', 'A', 'Se', 'O', 'N', 'D'],
      firstDayOfAWeek: 0
    }

    if (this.$router.currentRoute.name === 'home') {
      this.hideFooter = true
    }

    if (this.ie) {
      let blinkingCount = 0
      let maxBlinkingCount = 5
      let blinkingInterval = setInterval(() => {
        let theElement = document.getElementById('ie-warning')
        if (!theElement.classList.contains('blink')) theElement.classList.add('blink')
        else theElement.classList.remove('blink')
        if (blinkingCount++ >= maxBlinkingCount) clearInterval(blinkingInterval)
      }, 300)
    }
  }
}
</script>

<style lang="scss">

@import '@/scss/colors.scss';

.ie-warning {
  position: fixed;
  background: #2d2d2d;
  color: white;
  padding: 40px;
  font-size: 16px;
  top: 12px;
  left: 20px;

  &.blink {
    display: none;
  }
}

#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
  padding: 20px;
}

#nav {
  padding: 30px;

  a {
    font-weight: bold;
    color: #2c3e50;

    &.router-link-exact-active {
      color: #42b983;
    }
  }
}
.clickable {
  cursor: pointer;
}

.main-container {
  max-width: 1570px;
  margin: 0 auto;
  padding: 20px;
  @media(max-width: 600px){
    padding: 0px;
  }
}

.option-panel.fixed {
  position: fixed;
  right: 0;
  bottom: 0;
  width: 100%;
  background-color: #ffffffd4;
}

.option-panel {
  width: 100%;
  background-color: #ffffffd4;

  & .md-field.info {
    width: 160px !important;
    display: inline-block !important;
    margin-bottom: 0px !important;
    margin-right: 25px;
  }

  & .status-info {
    margin-right: 25px;

    &.waiting {
      background-color: $color-waiting-focus;
    }

    &.running {
      background-color: $color-running-focus;
    }

    &.done {
      background-color: $color-done-focus;
    }
  }

  & .align-right {
    text-align: right;
  }

  & .align-left {
    padding-left: 20px;
    text-align: left;
  }
}

.content-view {
  min-height: calc(100vh - 120px);
}

footer {
  height: 82px;
  text-align: center;

  &.hide {
    display: none;
  }

  .vs-logo-footer {
    padding-top: 5px;
    width: 75px;
    margin-right: 6%;
  }
  .crealp-logo {
    padding-top: 3px;
    width: 85px;
    margin-right: 5%;
  }
  .gaia-logo {
    padding-top: 3px;
    width: 60px;
  }
}

.md-tooltip {
  font-size: 14px !important;
}

.md-empty-state {
  user-select: none;
}

.md-chip.small {
  height: 25px;
  font-size: 12px;
  div.md-ripple {
    margin-top: -3px !important;
  }
}

.modal-container {
  padding: 15px;
  padding-top: 0px;
  overflow-y: auto;
}

.side-bar {
  width: 275px;
  border-right: 1px solid #949494;
  padding: 20px;
  margin-right: 20px;

  display: flex;
  flex-direction: column;

  &.right {
    border-right: none;
    border-left: 1px solid #949494;
  }

  &.disable {
    pointer-events: none;
    filter: blur(2px) brightness(40%);
    transition: 0.5s;
  }

  &.highlight {
    opacity: 0.5;
    transition: 0.1s;
  }

  .section {
    user-select: none;

    h3 {
      color: #bac1c5;
      border-bottom: 1px dotted #949494;
      width: calc(100% + 30px);
      display: block;
      margin-left: -25px;
    }
  }

}

.flex {
  display: flex;
}

.title-over-line {
  width: 100%;
  border-bottom: 1px solid #000;
  line-height: 0.1em;
  margin: 10px 0 20px;
}

.title-over-line span {
  background:#fff;
  padding:0 10px;
  margin-left: 20px;
}

@media(max-width: 1100px) {
  .side-bar {
    display: none;
    &.open {
      display: block;
    }
  }
}

.main-container.with-sidebar {
  display: flex;
  flex-wrap: nowrap;

  .main-content {
    flex-grow: 1;
    flex-wrap: nowrap;
    padding: 20px;
    width: 70%;
  }
}

</style>
